/* eslint-disable complexity */

import { Chart, registerables } from 'chart.js';

import { whiteCanvas, lineLegend } from './components/helpers';

// Register the necessary components for Chart.js.
Chart.register(...registerables);

window.addEventListener('DOMContentLoaded', () => {
  function handleChartData(importedDataset) {
    const {
      chartId,
      chartTitle,
      chartType,
      colorsArray,
      datasetsArray,
      labelsArray,
      displayLegend,
      displayTitle,
      xAxisLabelInput,
      yAxisLabelInput,
      displayXAxisLabel,
      displayYAxisLabel,
    } = importedDataset;

    const chartctx = document.getElementById(chartId);

    Chart.register(lineLegend);
    Chart.register(whiteCanvas);

    function generateChart(ctx, type, labels, datasets, text, axis) {
      const chartObj = {
        type,
        data: {
          labels,
          datasets,
        },
        options: {
          indexAxis: axis,
          responsive: true,
          plugins: {
            title: {
              display: displayTitle,
              text,
            },
            legend: {
              display: displayLegend,
            },
          },
          scales: {
            x: {
              title: {
                text: xAxisLabelInput,
                display: displayXAxisLabel,
              },
            },
            y: {
              title: {
                text: yAxisLabelInput,
                display: displayYAxisLabel,
              },
            },
          },
        },
      };
      if (type === 'pie' || type === 'doughnut' || type === 'radar') {
        chartObj.options.scales = false;
      }
      const myChart = new Chart(ctx, chartObj);
      return myChart;
    }

    if (chartctx) {
      const datasets = [];
      if (chartType === 'pie' || chartType === 'doughnut') {
        const { label, data, borderColor } = datasetsArray[0];
        const datasetObj = { label, data, backgroundColor: colorsArray, borderColor };
        datasets.push(datasetObj);
        generateChart(chartctx, chartType, labelsArray, datasets, chartTitle, 'x');
      }
      if (chartType === 'bar-horizontal' || chartType === 'bar-vertical') {
        datasetsArray.forEach((dataset) => {
          datasets.push(dataset);
        });
        if (chartType === 'bar-horizontal') {
          generateChart(chartctx, 'bar', labelsArray, datasets, chartTitle, 'y');
        } else {
          generateChart(chartctx, 'bar', labelsArray, datasets, chartTitle, 'x');
        }
      }
      if (chartType === 'line-vertical' || chartType === 'line-horizontal') {
        datasetsArray.forEach((dataset) => {
          datasets.push(dataset);
        });
        if (chartType === 'line-horizontal') {
          generateChart(chartctx, 'line', labelsArray, datasets, chartTitle, 'x');
        } else {
          generateChart(chartctx, 'line', labelsArray, datasets, chartTitle, 'y');
        }
      }
      if (chartType === 'radar') {
        datasetsArray.forEach((dataset) => {
          datasets.push(dataset);
        });
        generateChart(chartctx, 'radar', labelsArray, datasets, chartTitle, 'x');
      }
    }
  }

  const chartData = window.MediaPressBlocks_Chart_ChartData || [];

  if (chartData.length > 0) {
    chartData.forEach((importedDataset) => {
      handleChartData(importedDataset);
    });
  }
});
